import * as React from 'react'

import type Changes from 'modules/bookkeepers/store/collections/changes'
import type { Files } from 'modules/bookkeepers/store/collections/files'
import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'

export interface IncidenceDetailValue {
  loading: boolean
  incidenceDetailModel: IncidenceDetail
  incidenceChangesCollection: Changes
  incidenceFilesCollection: Files
}

const IncidenceDetailContext = React.createContext<IncidenceDetailValue | null>(null)

interface Props {
  incidenceDetails: IncidenceDetailValue
}

export const IncidenceDetailProvider = ({
  children,
  incidenceDetails,
}: React.PropsWithChildren<Props>) => (
  <IncidenceDetailContext.Provider value={incidenceDetails}>
    {children}
  </IncidenceDetailContext.Provider>
)

export const useIncidenceDetail = (): IncidenceDetailValue => {
  const values = React.useContext(IncidenceDetailContext)

  if (!values) {
    throw new Error('useIncidenceDetail must be used within an IncidenceDetailProvider')
  }

  return values
}
